module.exports = __webpack_public_path__ + "static/media/12.fed7f38c.svg";